module.exports = __webpack_public_path__ + "static/media/downItem.70d1227e.png";